export default {
    button: {
        marginRight: "32px",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#02599E",
        textTransform: "none",
    },
    menu: {
        marginTop: "10px",
        width: "380px",
        boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
    },
    menuItem: {
        width: "380px",
        display: "flex",
        justifyContent: "space-between",
        whiteSpace: "normal",
    },
    menuTitulo: {
        width: "188px",
        display: "block",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "18px",
        letterSpacing: "-0.04em",
        color: "#011328",
    },
    videoThumbnail: {
        width: "150px",
        height: "auto",
    },
    backdrop: {
        backgroundColor: "rgba(0,0,0,0.6) !important",
        zIndex: "99999",
    },
    videoClose: {
        position: "absolute",
        right: "30px",
        top: "30px",
        color: "white",
        cursor: "pointer",
    },
};
